const JOURNEY_TYPES = [
  { id: 'normal', name: 'энгийн' },
  { id: 'program', name: 'програм' },
];

export default JOURNEY_TYPES;